import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { Address } from 'src/app/models/address.model';

@Component({
  selector: 'app-address',
  templateUrl: './address.component.html',
  styleUrls: ['./address.component.scss']
})
export class AddressComponent implements OnInit {

  @Input() address: Address;
  @Input() type: any;
  @Output() formSubmit: EventEmitter<any> = new EventEmitter();


  constructor() { }

  ngOnInit() {

  }

  onSubmit(form) {
    this.formSubmit.emit();
  }

  getMinDate() {
    return new Date('01.01.1900');
  }

  getMaxDate() {
    return new Date();
  }

  isValidEmail(email) {
    let isValid = false;
    if (email) {
      const mailRegex = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
      if (mailRegex.test(email.toString())) {
        isValid = true;
      }
    }

    return isValid;
  }

}
